"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const Alert = ({
  className,
  children,
  type,
  size,
  inline
}) => {
  const classes = (0, _classnames.default)('Alert', {
    [`Alert-${type}`]: type
  }, {
    [`Alert-${size}`]: size
  }, {
    'Alert-inline': inline
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "Alert-content"
  }, children));
};
Alert.defaultProps = {
  type: 'neutral',
  size: 'md'
};
var _default = exports.default = Alert;